import { action } from 'app/actions';

export const GET_STUDENT_ANSWER_LIST = 'simulated/correction/GET_STUDENT_ANSWER_LIST';
export const getStudentAnswerList = payload => action(GET_STUDENT_ANSWER_LIST, { payload });

export const GET_STUDENT_ANSWER_DETAIL = 'simulated/correction/GET_STUDENT_ANSWER_DETAIL';
export const getStudentAnswerDetail = payload => action(GET_STUDENT_ANSWER_DETAIL, { payload });

export const GET_EVALUATION_INFORMATION = 'simulated/correction/GET_EVALUATION_INFORMATION';
export const getEvaluationInformation = payload => action(GET_EVALUATION_INFORMATION, { payload });

export const CORRECT_ANSWER_SHEET = 'simulated/correction/CORRECT_ANSWER_SHEET';
export const correctAnswerSheet = payload => action(CORRECT_ANSWER_SHEET, { payload });

export const RESET_CORRECTION = 'simulated/correction/RESET_CORRECTION';
export const resetCorrection = () => action(RESET_CORRECTION);

export const SET_LOADING = 'simulated/correction/SET_LOADING';
export const setLoading = payload => action(SET_LOADING, { payload });

export const CORRECTION_IN_PROGRESS = 'simulated/correction/CORRECTION_IN_PROGRESS';
export const setCorrectionInProgress = payload => action(CORRECTION_IN_PROGRESS, { payload });

export const CORRECTION_FINALIZED = 'simulated/correction/CORRECTION_FINALIZED';
export const setCorrectionFinalized = payload => action(CORRECTION_FINALIZED, { payload });

export const CORRECTION_GO_NEXT = 'simulated/correction/CORRECTION_GO_NEXT';
export const setCorrectionGoNext = payload => action(CORRECTION_GO_NEXT, { payload });

export const CORRECTION_WITH_SUCCESS = 'simulated/correction/CORRECTION_WITH_SUCCESS';
export const setCorrectionsWithSuccess = payload => action(CORRECTION_WITH_SUCCESS, { payload });

export const CORRECTION_RESPONSES = 'simulated/correction/CORRECTION_RESPONSES';
export const setCorrectionsResponses = payload => action(CORRECTION_RESPONSES, { payload });

export const REMOVE_ANSWER_SHEET = 'simulated/correction/REMOVE_ANSWER_SHEET';
export const removeAnswerSheet = payload => action(REMOVE_ANSWER_SHEET, { payload });

export const UPDATE_ANSWER_SHEET = 'simulated/correction/UPDATE_ANSWER_SHEET';
export const updateAnswerSheet = payload => action(UPDATE_ANSWER_SHEET, { payload });

export const ADD_ANSWER_SHEET = 'simulated/correction/ADD_ANSWER_SHEET';
export const addAnswerSheet = payload => action(ADD_ANSWER_SHEET, { payload });

export const FINALIZE_EVALUATION = 'simulated/correction/FINALIZE_EVALUATION';
export const finalizeEvaluation = payload => action(FINALIZE_EVALUATION, { payload });
